<template>
  <el-dialog
    v-model="localVisible"
    title="Duplicar Orden de Producción"
    width="520px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="reset"
  >
    <div
      v-if="isObsoleta"
      style="margin-bottom: 20px"
    >
      <el-alert
        title="Atención: Especificación Técnica Obsoleta"
        type="warning"
        description="Esta OT fue creada a partir de una ET que actualmente se encuentra obsoleta."
        show-icon
        :closable="false"
      />
      <div
        style="
          background-color: #fdf6ec;
          padding: 15px;
          border-radius: 4px;
          margin-top: 10px;
          border: 1px solid #faecd8;
        "
      >
        <p style="font-weight: 600; margin-bottom: 12px; color: #e6a23c">
          ¿Qué versión técnica desea utilizar para la copia?
        </p>
        <el-radio-group
          v-model="opcionET"
          style="display: flex; flex-direction: column; align-items: flex-start; gap: 10px"
        >
          <el-radio label="actualizar">
            <strong>Actualizar a la versión vigente</strong>
          </el-radio>
          <el-radio label="mantener">
            <strong>Mantener la versión obsoleta</strong>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div style="margin-bottom: 25px">
      Se duplicará la OP Nro <b>{{ codigoOT }}</b
      >. Ingrese la cantidad a producir.
    </div>

    <el-row :gutter="12">
      <custom-input-number
        v-model="form.cantidad"
        :label="'Cantidad'"
        :spanColumn="8"
        :settings="{
          placeholder: 'Cantidad',
          min: cantidadMinima,
          precision,
          step: 1,
          controls: false,
        }"
      />
    </el-row>

    <template #footer>
      <el-button
        size="default"
        @click="localVisible = false"
        >Cancelar</el-button
      >
      <el-button
        type="primary"
        size="default"
        :disabled="!isValid"
        @click="onConfirm"
      >
        Duplicar
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  computed,
  reactive,
  ref,
  watch,
} from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import { precisionCantidad } from '@/shared/utils/cantidad_unidad_venta.js';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  codigoOT: { type: Number, required: true },
  codigoUnidadVenta: { type: Number, default: null },
  initialCantidad: { type: Number, default: null },
  isObsoleta: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const localVisible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});

const showErrors = ref(false);
const opcionET = ref('actualizar');

const form = reactive({
  cantidad: null,
});

const precision = computed(() => precisionCantidad(props.codigoUnidadVenta));
const cantidadMinima = computed(() => (precision.value > 0 ? 10 ** -precision.value : 1));
const cantidadOk = computed(
  () => typeof form.cantidad === 'number' && form.cantidad >= cantidadMinima.value,
);
const isValid = computed(() => cantidadOk.value);

const reset = () => {
  showErrors.value = false;
  form.cantidad = props.initialCantidad ?? null;
  opcionET.value = 'actualizar';
};

watch(
  () => props.modelValue,
  (open) => {
    if (!open) return;
    reset();
  },
);

const onConfirm = () => {
  showErrors.value = true;
  if (!isValid.value) return;

  emit('confirm', {
    codigoOT: props.codigoOT,
    cantidad: form.cantidad,
    actualizarET: props.isObsoleta ? opcionET.value === 'actualizar' : true,
  });
};
</script>
